import ENDPOINTS from 'tradera-constants/endpoints';
import initData from 'init-data';

import {
    axiosConfigs,
    axiosWithTokenRefresh,
    finalizeResponse,
    handleError,
    API_ERRORS
} from 'tradera-utils/api';

export const getShippingProviders = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.SHIPPING_PROVIDERS, {
            ...axiosConfigs.authenticated
        })
        .then(finalizeResponse())
        .then(prepareResultForView)
        .catch(
            handleError({
                // Ignore 400 & 401 errors that slip through token refresh
                400: API_ERRORS.IGNORE_ME,
                401: API_ERRORS.IGNORE_ME
            })
        );
};

const GetRestrictionText = texts => {
    return texts.length === 0
        ? null
        : `<p className="mb-0"><strong>${texts[0]}</p>`;
};

const prepareResultForView = result => {
    return result.data.shippingProviders.map(shippingProvider => {
        shippingProvider.useAdvancedWidget =
            shippingProvider.products &&
            shippingProvider.products[0].variants &&
            shippingProvider.products[0].variants.length > 1;

        const promotedProviders = initData.featureSwitches[
            'dhl-integrated-booking-enabled'
        ]
            ? ['DBSchenker', 'PostNord', 'DHL']
            : ['DBSchenker', 'PostNord'];

        shippingProvider.promoted =
            promotedProviders.find(p => p === shippingProvider.id) !== undefined
                ? true
                : false;

        shippingProvider.isObsolete = shippingProvider.isObsolete || false;

        shippingProvider.products = shippingProvider.products.map(product => {
            product.validationError = null;
            product.cost = null;
            product.selected = false;
            product.isExtraInfoVisible = false;
            product.isBulkySelected = false;
            product.visible = product.type !== 'PostNordStamp';
            product.isValid = true;
            product.isStamps = product.type === 'PostNordStamp';

            product.variants = product.variants.map(variant => {
                if (product.type == 'PostNordStamp') {
                    variant.numberOfStamps =
                        variant.price / product.variants[0].price;
                }

                variant.restrictionText = GetRestrictionText(
                    variant.restrictionTexts
                );
                return variant;
            });

            return product;
        });

        return shippingProvider;
    });
};
